/*
 * Copyright (c) 2020.
 * Simon
 */

import React, {Component} from 'react';
import HearReply from "./HearReply";
import {toast} from 'react-toastify';
import i18n from "i18next";
import {connect} from "react-redux";
import {
    FanpageGetHearAction,
    HearGetDetailAction,
    HearGetDetailV2Action,
    HearUpdateAction,
    HearUpdateV2Action,
} from "../../actions";
import HearReplyCreate from "./HearReplyCreate";
import isTime2Click from "../../utils/isTime2Click";
import {Button} from "reactstrap";
import {HEAR_DETAIL_SUCCESS,HEAR_DETAIL_FAILURE,HEAR_UPDATE_SUCCESS,HEAR_UPDATE_FAILURE,
    FANPAGE_GET_HEARS_SUCCESS} from "../../types";
import ReactHtmlParser from "react-html-parser";
import issetFiled from "../../utils/issetFiled";

class HearReplies extends Component {

    static API_CALL_TIME_DELAY = 100;

    constructor(props) {
        super(props);

        this.state = {
            replyCount: 0,
            repliesData: [],
            hearId: props.hearId,
            hear: '',
            forGetStarted: props.forGetStarted,
            hearIdTemp:undefined
        }
    };

    actor() {
        return 'HearReplies';
    }

    componentWillReceiveProps(nextProps, nextContext) {

        this.setState({hearId: nextProps.hearId});

        this.handleHearDataReceive(nextProps);
        this.handleHearsDataReceiveV2(nextProps);
        this.handleUpdateHearRepliesV2(nextProps);
        // this.handleHearsDataReceive(nextProps);
    }

    componentDidMount() {
        this.setState({hearId: undefined});

        if (this.state.forGetStarted && this.state.hearId !== undefined) {
            this.props.hearGetDetailV2Action(this.state.hearId, this.props.fanpageId, this.actor());
            // this.props.hearGetDetailAction(this.state.hearId, this.props.fanpageId, this.actor());
        }

        // this.updateHearReplies(this.props);
    }

    handleHearsDataReceiveV2(nextProps) {
        if (nextProps.hearDetail === undefined) return;
        if (nextProps.hearDetail.data === undefined) return;
        if (![HEAR_DETAIL_SUCCESS,HEAR_DETAIL_FAILURE].includes(nextProps.hearDetail.data.action_type)) return;

        let hearGetDetail = nextProps.hearDetail.data;

        let replies = hearGetDetail.data.replies;

        this.setState({hear: hearGetDetail.data.hear});
        this.setState({repliesData: replies});
        this.setState({replyCount: replies.length});
        if(hearGetDetail.data.id !== undefined)
            this.setState({hearIdTemp: hearGetDetail.data.id});
        else
            this.setState({hearIdTemp: undefined});
    }

    showApproveStatus = (hearIdTemp) => {
        if (hearIdTemp === undefined) {
            return ReactHtmlParser('<span style="color: green">Approved</span>');
        } else {
            return ReactHtmlParser('<span style="color: red">Waiting for approve</span>');
        }
    }

    handleUpdateHearRepliesV2(nextProps) {
        if (nextProps.hearDetail === undefined) return;
        if (nextProps.hearDetail.data === undefined) return;
        if (![HEAR_UPDATE_SUCCESS,HEAR_UPDATE_FAILURE].includes(nextProps.hearDetail.data.action_type)) return;

        if (![FANPAGE_GET_HEARS_SUCCESS].includes(nextProps.hearDetail.data.action_type))
            this.props.fanpageGetHearAction(this.props.fanpageId, 'FanpageHearsList', this.props.currentPageHears);

        let hearUpdate = nextProps.hearDetail.data;

        let message = '';

        if(hearUpdate.data.id !== undefined){
            message = i18n.t("Waiting for approve");
            this.setState({hearIdTemp: hearUpdate.data.id});
        }else{
            message = i18n.t("Approved success");
            this.setState({hearIdTemp: undefined});
        }

        toast.success(message, {autoClose: 2000});
        setTimeout(function(){ window.location.reload(); }, 1100);
    }

    handleHearsDataReceive(nextProps) {

        if (nextProps.hears === undefined) {
            return;
        }

        this.updateHearReplies(nextProps);
    }

    updateHearReplies(props) {
        if (props.hearId === undefined) return;

        let hears = props.hears[this.props.fanpageId];
        if (hears === undefined) return;

        let hearGetDetail = hears[props.hearId];
        if (hearGetDetail === undefined) {
            this.props.hearGetDetailAction(props.hearId, this.props.fanpageId, this.actor());
            return;
        }

        let replies = hearGetDetail.replies;

        this.setState({hear: hearGetDetail.hear});
        this.setState({repliesData: replies});
        this.setState({replyCount: replies.length});
    }

    handleHearDataReceive(nextProps) {
        if (nextProps.hearDetail === undefined) return;
        if (nextProps.hearDetail.data === undefined) return;
        if (nextProps.hearDetail.data.actor !== this.actor()) return;

        let hearGetDetail = nextProps.hearDetail.data;

        if (this.isHearDataError(hearGetDetail)) {
            toast.error(i18n.t(hearGetDetail.message));
        }
    }

    isHearDataError(hearGetDetail) {
        return hearGetDetail.code === 1;
    }

    createReplies = () => {
        let replies = [];
        let textButton = 'Save Hear';
        let canAppvore = false;
        let isSuperAdmin = false;

        for (let i = 0; i < this.state.replyCount; i++) {
            replies.push(<HearReply
                key={i}
                fanpageId={this.props.fanpageId}
                replyIndex={i}
                hearReplies={this}
                hearId={this.props.hearId}
                repliesData={this.state.repliesData}
                replyData={this.state.repliesData[i]}
            />);

            replies.push(<hr color="darkblue" key={i + "hr"}/>);
        }

        if(issetFiled('user_funbot_v2')){
            JSON.parse(localStorage.getItem('user_funbot_v2')).abilities.forEach(ability => {
                if(ability.name === 'approve-hear')
                    canAppvore = true;
            });

            JSON.parse(localStorage.getItem('user_funbot_v2')).roles.forEach(role => {
                if(role.name === 'funbot-admin')
                    isSuperAdmin = true;
            });

        }
        if(canAppvore || isSuperAdmin){
            textButton = 'Approve'
        }

        replies.push(
            <Button
                className={"ApiButton"}
                key={98}
                id={'save_replies'}
                color={'primary'}
                size={'sm'}
                onClick={(e) => this.handleSaveClick(e)}
            >
                {i18n.t(textButton)}
            </Button>
        );

        replies.push(<HearReplyCreate
            key={99}
            id={'add_reply_button'}
            fanpageId={this.props.fanpageId}
            replyIndex={this.state.replyCount}
            hearReplies={this}
        />);

        return replies;
    };

    handleSaveClick = () => {
        if (!isTime2Click(this.actor())) return;
        this.setTimeToUpdate(this.state.repliesData);
    };

    updateReply(index, key, value) {

        let repliesData = this.state.repliesData;

        if (!repliesData[index]) repliesData[index] = {};
        repliesData[index] = Object.assign({}, repliesData[index]);
        repliesData[index][key] = value;

        if (value === HearReply.FACEBOOK_GENERIC) repliesData[index]['image_ratio'] = 'horizontal';

        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }

        this.setState({repliesData: repliesData});
    }

    setTimeToUpdate(repliesData, timeout = HearReplies.API_CALL_TIME_DELAY) {
        this.timer = setTimeout(() => {
            if (this.props.hearId === undefined) return;

            let hearData = {};
            hearData.replies = repliesData;

            // this.props.hearUpdateAction(this.props.hearId, this.props.fanpageId, hearData, this.actor());
            this.props.hearUpdateV2Action(this.props.hearId, this.props.fanpageId, hearData, this.actor());
        }, timeout);
    }

    addReply(repliesData, timeout = HearReplies.API_CALL_TIME_DELAY) {
        this.timer = setTimeout(() => {
            if (this.props.hearId === undefined) return;

            this.setState({replyCount: repliesData.length});

        }, timeout);
    }

    deleteReply = (index) => {
        let repliesData = this.state.repliesData;

        delete repliesData[index];

        repliesData = repliesData.filter(function (el) {
            return el != null;
        });
        toast.info(i18n.t("Deleting..."), {autoClose: 1500});

        this.timer = setTimeout(() => {
            if (this.props.hearId === undefined) return;

            let hearData = {};
            hearData.replies = repliesData;
            this.props.hearUpdateAction(this.props.hearId, this.props.fanpageId, hearData, this.actor());

            toast.success(i18n.t("Delete reply success"), {autoClose: 2000});
        }, HearReplies.API_CALL_TIME_DELAY);

        this.setState({repliesData: repliesData});
    };

    render() {
        if (this.state.hearId === undefined) return (<span> </span>);

        return (
            <div>
                <h5>{i18n.t("Edit")}: {this.state.hearId} - {this.state.hear} ({this.showApproveStatus(this.state.hearIdTemp)})</h5>
                <span style={{display: 'none'}}>hearId: {this.state.hearId}</span>
                {this.createReplies()}
            </div>
        );
    };
}


const mapStateToProps = (state) => {
    return {
        hearDetail: state.HearReducer,
        hears: state.HearsReducer,
    }
};

export default connect(mapStateToProps, {
    hearGetDetailAction: HearGetDetailAction,
    hearUpdateAction: HearUpdateAction,
    hearUpdateV2Action: HearUpdateV2Action,
    hearGetDetailV2Action: HearGetDetailV2Action,
    fanpageGetHearAction: FanpageGetHearAction,
})(HearReplies);